<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-lightborder table-striped table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Nit</th>
          <th>Serie</th>
          <th>Cliente</th>
          <th>Fecha</th>
          <th>Monto</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in data.results"
          v-bind:key="current.id"
          @click="rowClick(current)"
        >
          <td>{{ current.numero }}</td>
          <td v-if="current.cliente">{{ current.cliente.nombre }}</td>
          <td v-if="current.cliente == null"></td>
          <td v-if="current.abono_serie">{{ current.abono_serie.serie }}</td>
          <td v-if="current.abono_serie == null"></td>
          <td v-if="current.cliente">{{ current.cliente.nit }}</td>
          <td v-if="current.cliente == null"></td>
          <td>{{ current.fecha }}</td>
          <td>{{ current.total }}</td>
          <td class="text-center">
            <div
              data-title="Activo"
              data-toggle="tooltip"
              v-html="current.estado_str"
            ></div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  props: ["data"],
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      page: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cxc-abonos-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cxc-abonos-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      let self = this;
      this.currentPage = page;
      this.$emit("onPageChange", { page: page });
    },
  },
};
</script>
